/* ============
 * Order Transformer
 * ============
 *
 * The transformer for the order.
 */

import Transformer from './transformer';

export default class OrderPickupTransformer extends Transformer {
  static fetch(orderPickup) {
    return {
      id: orderPickup.id,
      orderId: orderPickup.order_id,
      organizationId: orderPickup.organization_id,
      shippingProviderId: orderPickup.shipping_provider_id,
      shippingStatusId: orderPickup.shipping_status_id,
      number: orderPickup.number,
      organization: orderPickup.organization,
      shippingProvider: orderPickup.shipping_provider,
      shippingStatus: orderPickup.shipping_status,
      pickupPriority: orderPickup.pickup_priority,
      note: orderPickup.note,
      pickupBy: orderPickup.pickup_by,
      pickupDate: orderPickup.pickup_date,
      shippingDate: orderPickup.shipping_date,
      deliveryDate: orderPickup.delivery_date,
      createdAt: orderPickup.created_at,
      trackingUrl: orderPickup.tracking_url,
      customerName: orderPickup.customer_name,
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/transformers/orderPickup.js